import type { BaseProductData } from '../types';
import notEmpty from '../../core/util/notEmpty';
import filterProducts from './filterProducts';

export type AvailabilityFilterValue = 'inStock' | 'available';

export interface FilterSelection {
    [name: string]: {
        type: string;
        value: string[];
    };
}

const collectValues = (
    products: BaseProductData[],
    name: string,
    type: string
) => {
    return Array.from(
        new Set(
            products
                .flatMap(product => {
                    if (type === 'variant') {
                        return product.variants
                            .flatMap(
                                variant =>
                                    variant.variationAttributes?.find(
                                        attribute => attribute.name === name
                                    )?.value ?? undefined
                            )
                            .filter(notEmpty);
                    }

                    if (type === 'sibling') {
                        return (
                            product.siblingAttributes?.find(
                                attribute => attribute.name === name
                            )?.value ?? undefined
                        );
                    }

                    return [];
                })
                .filter(notEmpty)
        )
    );
};

const getProductFilterValues = (
    products: BaseProductData[],
    selectedFilters: FilterSelection
) => {
    const filters = Object.entries(selectedFilters);
    return Object.fromEntries(
        filters.map(([name, { type }]) => {
            const otherFilters = filters.filter(
                ([filterName]) => filterName !== name
            );
            const [, productsFilteredByOthers] = filterProducts(products, {
                ...Object.fromEntries(otherFilters),
                [name]: {
                    type,
                    value: [],
                },
            } as FilterSelection);

            return [
                name,
                {
                    type,
                    value: collectValues(productsFilteredByOthers, name, type),
                },
            ];
        })
    );
};

export default getProductFilterValues;
